import React, { useEffect, useState } from "react";
import defaultimg from "../Assets/Images/default.jpg";

const ImageWithFallback = ({ src, alt, ...props }) => {
  const [imageSrc, setImageSrc] = useState(src);
  useEffect(() => {
    setImageSrc(src || defaultimg);
  }, [src]);
  const handleError = () => {
    setImageSrc(defaultimg);
  };

  return (
    <img
      src={imageSrc}
      alt={alt}
      onError={handleError}
      {...props} // Spread other props like className, style, etc.
    />
  );
};

export default ImageWithFallback;
